import React from 'react'

import FindFriends from 'v2/components/FindFriends'

export const FindFriendsTab: React.FC = () => {
  return <FindFriends />
}
